export default "__VITE_ASSET__CHZMq1m2__"